import { render } from "./Dropzone.vue?vue&type=template&id=09f2402a"
import script from "./Dropzone.vue?vue&type=script&lang=js"
export * from "./Dropzone.vue?vue&type=script&lang=js"

import "./Dropzone.vue?vue&type=style&index=0&id=09f2402a&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__